import React, { useState, useEffect } from 'react';
import PageTabs from '../shared/PageTabs';
import { SETTINGS_TABS } from '../shared/tabConfigs';
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Paper, 
  //CircularProgress,
} from '@mui/material';
//import { settingsService } from '../../services/api';
import GeneralEmailTemplates from './GeneralEmailTemplates';
// import LearningActivityTemplates from './LearningActivityTemplates';
// import RemindersTemplates from './RemindersTemplates';
import EmailConfiguration from './EmailConfiguration';

function EmailTemplates() {
  const [activeTab, setActiveTab] = useState(0);
  //const [loading, setLoading] = useState(false);
  const [tabComponents, setTabComponents] = useState({
    0: null, // General
    // 1: null, // Learning Activity
    // 2: null, // Reminders & Updates
    1: null  // Settings
  });

  useEffect(() => {
    const lastTab = localStorage.getItem('emailTemplatesLastTab');
    if (lastTab) {
      setActiveTab(parseInt(lastTab, 10));
    }
  }, []);
  
  useEffect(() => {
    const newTabComponents = { ...tabComponents };
    switch(activeTab) {
      case 0:
        newTabComponents[0] = <GeneralEmailTemplates />;
        break;
      // case 1:
      //   newTabComponents[1] = <LearningActivityTemplates />;
      //   break;
      // case 2:
      //   newTabComponents[2] = <RemindersTemplates />;
      //   break;
     // case 1:
        //newTabComponents[1] = <EmailConfiguration />;
        //break;
      default:
        break;
    }
    
    setTabComponents(newTabComponents);
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    localStorage.setItem('emailTemplatesLastTab', newValue.toString());
  };
  
  return (
    // <Container maxWidth="lg">
    <Box sx={{ p: 2 }}>
      <PageTabs tabs={SETTINGS_TABS} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        
        <Typography variant="h4" gutterBottom className='page-title'>
          Email Templates Settings
        </Typography>
      </Box>

      
        {/* 
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="General" />
          <Tab label="Learning Activity" />
          <Tab label="Reminders & Updates" /> 
          <Tab label="Settings" />
        </Tabs>*/}

        <Box sx={{ p: 3 }}>
          {/*tabComponents[activeTab]*/}
          {tabComponents[0]}
        </Box>
      
    </Box>
  );
}

export default EmailTemplates;